"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerSplitAction = void 0;
class PlayerSplitAction {
    get movedCardIndex() {
        var _a;
        return (_a = this.card) === null || _a === void 0 ? void 0 : _a.index;
    }
    constructor(board, currentPlayerPileId, nextPlayerPileId) {
        this.board = board;
        this.currentPlayerPileId = currentPlayerPileId;
        this.nextPlayerPileId = nextPlayerPileId;
    }
    execute() {
        const originPile = this.board.getPileByPileId(this.currentPlayerPileId);
        if (originPile.cardCount !== 2) {
            throw new Error("Player pile does not contain only 2 cards to split");
        }
        this.card = originPile.lastCard;
        if (this.card === undefined) {
            throw new Error("Invalid final deck card");
        }
        const targetPile = this.board.getPileByPileId(this.nextPlayerPileId);
        originPile.removeCard(this.card);
        targetPile.addCard(this.card);
    }
    resolve() {
        // Nothing
    }
    static isAction(action) {
        return action instanceof PlayerSplitAction;
    }
}
exports.PlayerSplitAction = PlayerSplitAction;
